
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata, GridMetadata, IDocument } from "@tylertech/tyler-api-types";

/**
 * ReceiveGoodsService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ReceiveGoodsService<TGoodsReceived = unknown, TPOPurchaseOrderItem = unknown> {
    private readonly $apiService = inject(ApiService);
    
    CreateNewGoodsReceived(pItem: TPOPurchaseOrderItem): Promise<TGoodsReceived> {
        return this.$apiService.sendAuth("IReceiveGoodsService/CreateNewGoodsReceived", pItem);
    }
    DeleteGoodsReceived(pGoodsReceivedId: string): Promise<void> {
        return this.$apiService.sendAuth("IReceiveGoodsService/DeleteGoodsReceived", pGoodsReceivedId);
    }
    GetGoodsReceived(pItem: TPOPurchaseOrderItem, filterString?: string): Promise<TGoodsReceived[]> {
        return this.$apiService.sendAuth("IReceiveGoodsService/GetGoodsReceived", pItem, filterString);
    }
    GetGoodsReceivedGridMetadata(isService: boolean): Promise<GridMetadata> {
        return this.$apiService.sendAuth("IReceiveGoodsService/GetGoodsReceivedGridMetadata", isService);
    }
    GetPurchaseOrderItemMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IReceiveGoodsService/GetPurchaseOrderItemMetadata");
    }
    GetPurchaseOrderItems(pId: string, filterString?: string): Promise<TPOPurchaseOrderItem[]> {
        return this.$apiService.sendAuth("IReceiveGoodsService/GetPurchaseOrderItems", pId, filterString);
    }
    PrintReceivedDocument(POPurchaseOrderId: string): Promise<IDocument> {
        return this.$apiService.sendAuth("IReceiveGoodsService/PrintReceivedDocument", POPurchaseOrderId);
    }
    SaveGoodsReceived(pGoodsReceived: TGoodsReceived[]): Promise<TGoodsReceived[]> {
        return this.$apiService.sendAuth("IReceiveGoodsService/SaveGoodsReceived", pGoodsReceived);
    }
}
